import {Injectable} from "@angular/core";
import {RequesterService} from "../../../../shared/services/requester/requester.service";
import * as fromStore from "../../../../store";
import {Store} from "@ngrx/store";
import {DbStoreState} from "../../../../store";
import {combineLatest} from "rxjs";
import {Observable} from "rxjs";
import { HttpClient } from "@angular/common/http";
import {Config} from "../../../../config/config";
import {DbResponse} from "../../../../shared/interceptors/db-response";
import mockData from "../../../../../assets/json/mock-data.json";
import {BehaviorSubject} from "rxjs";

@Injectable()
export class CustomersService {
  private _ownerWorkspaceId: number;
  private _currentWorkspaceId: number;

  constructor(private _requester: RequesterService,
              private _httpClient: HttpClient,
              private _store: Store<DbStoreState>) {
    this._getWorkspaceEntities();
  }


  getCustomers(domainID: number, params): Observable<any> {
    if (domainID === Config.demoDomainId) {
      const response: any = mockData['customers'];
      return new BehaviorSubject<DbResponse>(response);
    }
    return this._requester.tenWebWoocom
      .get(`workspaces/${this._currentWorkspaceId}/domains/${domainID}?endpoint=reports/customers`, params, true);
  }

  getCustomerById(domainID: number, id: number) {
    return this._requester.tenWebWoocom
      .get(`workspaces/${this._currentWorkspaceId}/domains/${domainID}?endpoint=customers/${id}`, null, true);
  }

  deleteCustomer(domainID: number, id: number): Observable<any> {
    return this._requester.woocom
      .delete(`workspaces/${this._currentWorkspaceId}/domains/${domainID}?endpoint=customers/${id}`);
  }

  private _getWorkspaceEntities(): void {
    combineLatest(
      this._store.select(fromStore.getUserSubscription),
      this._store.select(fromStore.getWorkspaceIdEntities)
    ).subscribe(([userSubscription, workspaceIdEntities]) => {
      this._ownerWorkspaceId = workspaceIdEntities.ownerWorkspaceId;
      this._currentWorkspaceId = workspaceIdEntities.currentWorkspaceId || this._ownerWorkspaceId;
    });
  }

}
